import { render } from "./AdminBlock.vue?vue&type=template&id=f6c266b0&scoped=true"
import script from "./AdminBlock.vue?vue&type=script&lang=js"
export * from "./AdminBlock.vue?vue&type=script&lang=js"

import "./AdminBlock.vue?vue&type=style&index=0&id=f6c266b0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c266b0"]])

export default __exports__